import { cn } from '@/lib/cn'

export interface SpinnerProps {
  size?: number
  className?: string
  /** Supply when the spinner is the only thing on screen, so the wait is announced. */
  label?: string
}

/** Hidden from assistive technology unless given a label — a bare spinner announces nothing useful. */
export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn('inline-block shrink-0', className)}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 24 24" width={size} height={size} fill="none" focusable="false">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.2" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          className="motion-safe:animate-spin motion-safe:origin-center"
        />
      </svg>
    </span>
  )
}
